import { createAction } from '@ngrx/store';
import { PublisherAccount } from 'app/modules/main/models/account';
import { AdvertiserAccount } from 'app/modules/main/models/account';
import { Authorization } from 'app/modules/main/models/authorization';

export class UserAuthorizationActions {

  static readonly userClaimingAuthorizationForAdvertiserAccount =
    createAction(
      '[User Authorization Feature] User Claiming Authorization For Advertiser Account',
      (account: AdvertiserAccount) => ({ account }),
    );

  static readonly userAuthorizedForAdvertiserAccount =
    createAction(
      '[User Authorization Feature] User Authorized For Advertiser Account',
      (authorization: Authorization<AdvertiserAccount>) => ({ authorization }),
    );

  static readonly userUnauthorizedForAdvertiserAccount =
    createAction(
      '[User Authorization Feature] User *Unauthorized* For Advertiser Account',
      (error?: string) => ({ error }),
    );

  static readonly userClaimingAuthorizationForPublisherAccount =
    createAction(
      '[User Authorization Feature] User Claiming Authorization For Publisher Account',
      (account: PublisherAccount) => ({ account }),
    );

  static readonly userAuthorizedForPublisherAccount =
    createAction(
      '[User Authorization Feature] User Authorized For Publisher Account',
      (authorization: Authorization<PublisherAccount>) => ({ authorization }),
    );

  static readonly userUnauthorizedForPublisherAccount =
    createAction(
      '[User Authorization Feature] User *Unauthorized* For Publisher Account',
      (error?: string) => ({ error }),
    );

  static readonly authorizationRefreshRequestedForAdvertiserAccount =
    createAction(
      '[User Authorization Feature] Refresh requested For Advertiser Account',
      (authorization: Authorization<AdvertiserAccount>) => ({ authorization }),
    );

  static readonly userAuthorizationRefreshedForAdvertiserAccount =
    createAction(
      '[User Authorization Feature] User Authorization Refreshed For Advertiser Account',
      (authorization: Authorization<AdvertiserAccount>) => ({ authorization }),
    );

  static readonly authorizationRefreshRequestedForPublisherAccount =
    createAction(
      '[User Authorization Feature] Refresh requested For Publisher Account',
      (authorization: Authorization<PublisherAccount>) => ({ authorization }),
    );

  static readonly userAuthorizationRefreshedForPublisherAccount =
    createAction(
      '[User Authorization Feature] User Authorization Refreshed For Publisher Account',
      (authorization: Authorization<PublisherAccount>) => ({ authorization }),
    );

}
